export default class AuthTokenExpiredError extends Error {
  constructor(message) {
    super(message)
    this.name = "AuthTokenExpiredError"
  }
}
